<div class="w-full flex flex-col gap-4 p-4">
    <div class="w-full flex sm:flex-row flex-col items-center justify-between gap-4">
        <h1 class="text-2xl font-bold">Ncm</h1>

        <app-button
            (click)="incluir()"
            variant="success"
            class="md:max-w-45 w-full"
        >
            Incluir
        </app-button>
    </div>

    <app-input-search
        [(ngModel)]="filtro"
        label="Pesquisar Ncm"
        (keydown.enter)="filtrar()"
        (search)="filtrar()"
        class="w-full"
    ></app-input-search>

    <p-table
        (onPage)="paginate($event)"
        [paginator]="true"
        [rowsPerPageOptions]="opcoesLinha"
        [(rows)]="qtdLinhas"
        [totalRecords]="totalItens"
        [value]="lista"
        [lazy]="true"
    >
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th class="w-[70%] min-w-30">Descrição</th>
                <th class="w-[20%] min-w-30">Ncm</th>
                <th class="w-[10%] min-w-10">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{ rowData.Descricao }}</td>
                <td>{{ rowData.Ncm }}</td>
                <td>
                    <app-opcoes-table
                        [value]="rowData"
                        [opcoes]="opcoesTable"
                    ></app-opcoes-table>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
